import React from 'react';
import {Paper, IconButton, Tabs, Tab} from 'material-ui';
import StationSpecificMap from './StationSpecificMap';
import Observation from './Observation';
import {Carousel, CarouselItem} from "react-bootstrap";
import LatestObservation from "./LatestObservation";

class StationInfoMob extends React.Component {
  style = {width: '100%', padding: '10px', marginBottom: '10px'};

  render() {
    const {station, rainfall, waterlevel, toggleOpen} = this.props;
    return (
      <div className="stationDetails">
        <Paper style={this.style} zDepth={2}>
          <div className="column-it">
            <div>
              <div className="stationTitle">
                {station.name}
                <IconButton className='pull-right' style={{marginTop: '-8px'}}
                            iconClassName='glyphicon glyphicon-menu-hamburger' onClick={toggleOpen}/>
              </div>
              <table className="table">
                <tbody>
                <tr>
                  <th>Station Index</th>
                  <td>{waterlevel && waterlevel.stationIndex}</td>
                </tr>
                {/*<tr><th>Name</th><td>{this.station.name}</td></tr>*/}
                <tr>
                  <th>Latitude</th>
                  <td>{station.position.lat}</td>
                </tr>
                <tr>
                  <th>Longitude</th>
                  <td>{station.position.lng}</td>
                </tr>
                <tr>
                  <th>Elevation</th>
                  <td>{station.elevation}</td>
                </tr>
                <tr>
                  <th>District</th>
                  <td>{waterlevel && waterlevel.district ? waterlevel.district : rainfall && rainfall.district? rainfall.district : ''}</td>
                </tr>
                <tr>
                  <th>Description</th>
                  <td>{station.description}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div>
              <StationSpecificMap
                station={{...station, icon: waterlevel ? waterlevel.icon : station.icon}}/>
            </div>
            <br/>
            {station.images &&
            <Carousel animation={true} indicators={true} slide={true}>
              {station.images.map((image, i) => (
                <CarouselItem key={i} style={{width:'100%'}}>
                  <img src={`http://daq.hydrology.gov.np/images/${image.name}`} alt="not found"/>
                </CarouselItem>
              ))}
            </Carousel>}
          </div>
        </Paper>
        {(waterlevel || rainfall) && <LatestObservation waterLevel={waterlevel} rainfall={rainfall} mobView/>}
        {((waterlevel && waterlevel.series_id) || (rainfall && rainfall.series_id)) &&
        <Paper zDepth={2}>
          <Observation mobView waterLevelId={waterlevel && waterlevel.series_id} rainfallId={rainfall && rainfall.series_id} thresholds={waterlevel && waterlevel.thresholds}/>
        </Paper>}
        <br/>
      </div>
    );
  }
}

export default StationInfoMob;



// WEBPACK FOOTER //
// ./src/components/Station/StationInfoMob.js